<template>
  <div class="mt-6">
    <div
      v-for="categoriesLength in 2"
      :key="categoriesLength"
      class="page-home-categories"
    >
      <category
        v-for="category in categories.slice(
          (categoriesLength - 1) * Math.round(categories.length / 2),
          categoriesLength * Math.round(categories.length / 2)
        )"
        :key="category"
        :category="category"
        class="mt-3"
      ></category>

      <banner v-if="categoriesLength == 1 && !xs" type="center-3-a" />

      <banner v-if="categoriesLength == 1 && !xs" type="center-3-b" />
    </div>
  </div>
</template>

<script>
import Category from "@/components/widgets/Category.vue";
import Banner from "@/components/cards/Banner.vue";

export default {
  data: () => ({
    categories: [
      "Desenvolvimento",
      "Tecnologia",
      "Política",
      "Educação",
      "Comércio",
      "Economia",
      "Meio Ambiente",
      "Agronegócio",
      "Cidades",
      "Turismo",
      "Saúde",
      "Gastronomia",
    ],
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    Category,
    Banner,
  },
};
</script>

<style>
.page-home-categories {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

@media screen and (max-width: 600px) {
  .page-home-categories {
    grid-template-columns: 1fr;
  }
}
</style>
